import React, {
  Fragment,
  useContext,
  useState,
  useEffect,
  // useRef,
} from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
  Paper,
  Checkbox,
  // Button,
  // Popper,
  // Grow,
  // ClickAwayListener,
  // MenuList,
  // MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
// import Moment from "moment";
// import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

const useStyles = makeStyles((theme) => ({
  // root: { maxHeight: 493 },
  root: {
    height: 447,
  },
  // button: { textTransform: "none", "&:focus": { outline: "none" } },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  // header1: { zIndex: theme.zIndex.appBar },
  // header2: { top: 46 },
  header2: {
    zIndex: theme.zIndex.mobileStepper,
  },
  cell: {
    minWidth: 120,
    borderRight: "1px solid lightgrey",
  },
  cell_none: {
    border: "none",
    height: 45,
  },
  cell_note: {
    fontSize: 11,
    color: "grey",
  },
  body: {
    marginBottom: 50,
  },
  footer: {
    bottom: 0,
    zIndex: theme.zIndex.mobileStepper,
    fontWeight: "bold",
    borderTop: "1px solid lightgrey",
  },
  fixedCheckbox_header: {
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.speedDial,
  },
  fixedCell_header: {
    left: 49,
    position: "sticky",
    zIndex: theme.zIndex.speedDial,
    borderRight: "2px solid lightgrey",
  },
  fixedCheckbox_body: {
    left: 0,
    position: "sticky",
    // zIndex: theme.zIndex.mobileStepper,
    backgroundColor: "#fff",
  },
  fixedCell_body: {
    left: 49,
    position: "sticky",
    // zIndex: theme.zIndex.mobileStepper,
    backgroundColor: "#fff",
    borderRight: "2px solid lightgrey",
  },
}));

// const DashboardStats_02 = ({ current_tab }) => {
const DashboardStats_02 = () => {
  const classes = useStyles();

  const {
    campaign_stats,
    selected_fb_details,
    selected_profile,
    campaign_selected,
    setCampaignSelected,
    stats_name_filter,
    campaign_filtered,
    // stats_date_filter,
    // setStatsDateFilter,
  } = useContext(FacebookProfilesDashboardContext);

  // // DATE FILTER
  // const [dateOpen, setDateOpen] = useState(false);
  // const anchorRef = useRef(null);

  // const handleToggle = () => {
  //   setDateOpen((prevOpen) => !prevOpen);
  // };

  // const handleClose = (e) => {
  //   if (anchorRef.current && anchorRef.current.contains(e.target)) {
  //     return;
  //   }

  //   setDateOpen(false);
  // };

  // const handleListKeyDown = (e) => {
  //   if (e.key === "Tab") {
  //     e.preventDefault();
  //     setDateOpen(false);
  //   }
  // };

  // const handleSelect = (e) => {
  //   let newDate = new Date();
  //   let startDate, endDate;

  //   if (e.target.id === "Yesterday") {
  //     newDate.setDate(newDate.getDate() - 1);
  //     let date = Moment(newDate, "YYYY-MM-DD");
  //     date = date.format();

  //     startDate = date.substring(0, date.indexOf("T"));
  //     endDate = date.substring(0, date.indexOf("T"));
  //   }

  //   setStatsDateFilter(startDate, endDate);
  //   handleClose(e);
  // };

  // TABLE
  const createHead = (id, label, align, disablePadding) => {
    return {
      id,
      label,
      align,
      disablePadding,
    };
  };

  const heads = [
    createHead("name", "Campaign Name", "left", true),
    createHead("delivery", "Delivery", "left", false),
    createHead("spend", "Amount Spend", "left", false),
    createHead("daily_budget", "Budget", "left", false),
    createHead("results", "Results", "left", false),
    createHead("cost_per_result", "Cost Per Result", "left", false),
    createHead("purchase_roas", "Purchase ROAS", "left", false),
    createHead("purchase_roas_value", "Purchase ROAS Value", "left", false),
    createHead("cpc", "CPC", "left", false),
    createHead("ctr", "CTR", "left", false),
    createHead("video_view", "Video Average Watch Time", "left", false),
  ];

  const summary_template = {
    campaign: 0,
    spend: "",
    daily_budget: 0.0,
    results: "",
    cost_per_result: "",
    purchase_roas: "",
    purchase_roas_value: "",
    cpc: "",
    ctr: "",
    video_view: "",
  };

  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(summary_template);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [title_01, setTitle01] = useState("");
  // const [selected, setSelected] = useState([]);

  const onSelectAllClick = (e) => {
    if (e.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setCampaignSelected(newSelecteds);
      return;
    }

    setCampaignSelected([]);
  };

  const onClick = (e, name) => {
    const selectedIndex = campaign_selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(campaign_selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(campaign_selected.slice(1));
    } else if (selectedIndex === campaign_selected.length - 1) {
      newSelected = newSelected.concat(campaign_selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        campaign_selected.slice(0, selectedIndex),
        campaign_selected.slice(selectedIndex + 1)
      );
    }

    setCampaignSelected(newSelected);
  };

  const onRequestSort = (e, prop) => {
    const isAsc = orderBy === prop && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(prop);
  };

  const createSortHandler = (property) => (e) => {
    onRequestSort(e, property);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    return stabilizedThis.map((el) => el[0]);
  };

  const textTransform = (text) => {
    return text.toUpperCase().replace(/\_/g, " ");
  };

  useEffect(() => {
    //  Stats Subtitle
    if (selected_profile.adset) {
      let optimization_goal = "";

      for (let x in selected_profile.adset) {
        if (selected_profile.adset[x].optimization_goal) {
          // Convert To Pascal Case
          optimization_goal = selected_profile.adset[x].optimization_goal;
          optimization_goal = optimization_goal.replace("_", " ");
          optimization_goal = optimization_goal.replace(/\w+/g, function (w) {
            return w[0].toUpperCase() + w.slice(1).toLowerCase();
          });
        }
      }

      setTitle01(optimization_goal);
    }

    let delivery = "";

    selected_profile.ad_account.map((each) => {
      if (each.ad_account_id === selected_fb_details.ad_account) {
        // if (each.ad_account_status === 1) delivery = "ACTIVE";
        // else
        if (each.ad_account_status === 2) delivery = "DISABLED";
      }
    });

    let campaign = 0;
    let spend = 0.0;
    let daily_budget = 0.0;
    let results = 0;
    let cost_per_result = 0.0;
    // let purchase_roas = 0.0;
    let purchase_roas_value = 0.0;
    let cpc = 0.0;
    let ctr = 0.0;
    let video_view = 0.0;

    let rows = [];
    let summary = summary_template;

    if (stats_name_filter["Campaign"] !== "") {
      campaign_filtered.map((each) => {
        campaign += 1;
        spend += parseFloat(each.spend);
        daily_budget += parseFloat(each.daily_budget);
        results += parseInt(each.results);
        cost_per_result += parseFloat(each.cost_per_result);
        // purchase_roas += parseFloat(each.purchase_roas);
        purchase_roas_value += parseFloat(each.purchase_roas_value);
        cpc += parseFloat(each.cpc);
        ctr += parseFloat(each.ctr);
        video_view += parseFloat(each.video_view);

        if (delivery === "DISABLED") each.delivery = delivery;

        rows.push(each);
      });
    } else {
      campaign_stats.map((each) => {
        campaign += 1;
        spend += parseFloat(each.spend);
        daily_budget += parseFloat(each.daily_budget);
        results += parseInt(each.results);
        cost_per_result += parseFloat(each.cost_per_result);
        // purchase_roas += parseFloat(each.purchase_roas);
        purchase_roas_value += parseFloat(each.purchase_roas_value);
        cpc += parseFloat(each.cpc);
        ctr += parseFloat(each.ctr);
        video_view += parseFloat(each.video_view);

        if (delivery === "DISABLED") each.delivery = delivery;

        rows.push(each);
      });
    }

    if (rows.length > 0) {
      summary = {
        campaign,
        spend: spend.toFixed(2),
        daily_budget: daily_budget.toFixed(2),
        results,
        cost_per_result: cost_per_result.toFixed(2),
        // purchase_roas: purchase_roas.toFixed(2),
        purchase_roas: (purchase_roas_value / spend || 0).toFixed(2),
        purchase_roas_value: purchase_roas_value.toFixed(2),
        cpc: cpc.toFixed(2),
        ctr: ctr.toFixed(2),
        video_view: video_view.toFixed(2),
      };
    }

    while (rows.length < 7) rows.push({});

    setRows(rows);
    setSummary(summary);
  }, [selected_fb_details, campaign_stats, campaign_filtered]);

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table size="small" stickyHeader className={classes.root}>
        <TableHead>
          {" "}
          {/* <TableRow>
                        <TableCell
                          colSpan={2}
                          align="center"
                          className={classes.fixedCheckbox_header}
                        >
                          <Button
                            variant="outlined"
                            color="primary"
                            className={classes.button}
                            // onClick={}
                          >
                            Create {current_tab}
                          </Button>
                        </TableCell>

                        <TableCell colSpan={6} align="right" className={classes.header1}>
                          <Button
                            variant="outlined"
                            color="primary"
                            style={{ width: "7rem" }}
                            className={classes.button}
                            ref={anchorRef}
                            aria-controls={dateOpen ? "stats-date-filter" : undefined}
                            aria-haspopup={true}
                            onClick={handleToggle}
                          >
                            {stats_date_filter.name} <ArrowDropDownRoundedIcon />
                          </Button>

                          <Popper
                            transition
                            disablePortal
                            role={undefined}
                            anchorEl={anchorRef.current}
                            open={dateOpen}
                          >
                            {({ TransitionProps, placement }) => (
                              <Grow
                                {...TransitionProps}
                                style={{ transformOrigin: placement }}
                              >
                                <Paper>
                                  <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList
                                      id="stats-date-filter"
                                      autoFocusItem={dateOpen}
                                      onKeyDown={handleListKeyDown}
                                    >
                                      <MenuItem id="Today" onClick={handleSelect}>
                                        Today
                                      </MenuItem>
                                      <MenuItem id="Yesterday" onClick={handleSelect}>
                                        Yesterday
                                      </MenuItem>
                                    </MenuList>
                                  </ClickAwayListener>
                                </Paper>
                              </Grow>
                            )}
                          </Popper>
                        </TableCell>
                      </TableRow> */}
          <TableRow>
            <TableCell
              padding="checkbox"
              className={clsx(classes.header2, {
                [classes.fixedCheckbox_header]: true,
              })}
            >
              <Checkbox
                indeterminate={
                  campaign_selected.length > 0 &&
                  campaign_selected.length < rows.length
                }
                checked={
                  rows.length > 0 && campaign_selected.length === rows.length
                }
                onChange={onSelectAllClick}
              />{" "}
            </TableCell>
            {heads.map((head, index) => (
              <TableCell
                key={index}
                align={head.align}
                padding={head.disablePadding ? "none" : "default"}
                sortDirection={orderBy === head.id ? order : false}
                className={clsx(classes.header2, {
                  [classes.fixedCell_header]: index === 0,
                  [classes.cell]: index !== 0,
                })}
              >
                <TableSortLabel
                  active={orderBy === head.id}
                  direction={orderBy === head.id ? order : "asc"}
                  onClick={createSortHandler(head.id)}
                >
                  {head.label}{" "}
                  {orderBy === head.id ? (
                    <span className={classes.visuallyHidden}>
                      {" "}
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}{" "}
                    </span>
                  ) : null}{" "}
                </TableSortLabel>{" "}
              </TableCell>
            ))}{" "}
          </TableRow>{" "}
        </TableHead>
        <TableBody className={classes.body}>
          {" "}
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            const isItemSelected = campaign_selected.indexOf(row.id) !== -1;

            return Object.keys(row).length > 0 ? (
              <TableRow
                key={index}
                hover
                role="checkbox"
                tabIndex={-1}
                selected={isItemSelected}
                onClick={(e) => onClick(e, row.id)}
              >
                <TableCell
                  padding="checkbox"
                  className={classes.fixedCheckbox_body}
                >
                  <Checkbox checked={isItemSelected} />{" "}
                </TableCell>{" "}
                <TableCell
                  align="left"
                  padding="none"
                  className={clsx(classes.cell, {
                    [classes.fixedCell_body]: true,
                  })}
                >
                  {row.name}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {textTransform(row.delivery)}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  $ {row.spend}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  $ {row.daily_budget}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  <Fragment>
                    {" "}
                    {row.results ? row.results : "-"} <br />
                    <span className={classes.cell_note}> {title_01} </span>{" "}
                  </Fragment>{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  <Fragment>
                    {" "}
                    {row.cost_per_result ? `$${row.cost_per_result}` : "-"}{" "}
                    <br />
                    <span className={classes.cell_note}>
                      {" "}
                      Per {title_01}{" "}
                    </span>{" "}
                  </Fragment>{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.purchase_roas ? row.purchase_roas : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.purchase_roas_value ? row.purchase_roas_value : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.cpc ? row.cpc : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.ctr ? row.ctr : "-"}{" "}
                </TableCell>{" "}
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {row.video_view}{" "}
                </TableCell>{" "}
              </TableRow>
            ) : (
              <TableRow key={index}>
                <TableCell
                  colSpan={10}
                  className={classes.cell_none}
                ></TableCell>{" "}
              </TableRow>
            );
          })}{" "}
        </TableBody>
        <TableHead>
          {" "}
          {/* {summary && ( */}{" "}
          <TableRow>
            <TableCell
              padding="checkbox"
              className={clsx(classes.footer, {
                [classes.fixedCheckbox_header]: true,
              })}
            ></TableCell>{" "}
            <TableCell
              align="left"
              className={clsx(classes.footer, {
                [classes.fixedCell_header]: true,
              })}
            >
              Results from {summary.campaign}
              campaigns{" "}
            </TableCell>{" "}
            <TableCell className={classes.footer}> </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.spend} <br />
              <span className={classes.cell_note}> Total Spent </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.daily_budget} <br />
              <span className={classes.cell_note}> Total Budget </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.results} <br />
              <span className={classes.cell_note}> {title_01} </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.cost_per_result} <br />
              <span className={classes.cell_note}> Per {title_01} </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.purchase_roas} <br />
              <span className={classes.cell_note}> Average </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              $ {summary.purchase_roas_value} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.cpc} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.ctr} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
            <TableCell align="left" className={classes.footer}>
              {" "}
              {summary.video_view} <br />
              <span className={classes.cell_note}> Total </span>{" "}
            </TableCell>{" "}
          </TableRow>{" "}
          {/* )} */}{" "}
        </TableHead>{" "}
      </Table>{" "}
    </TableContainer>
  );
};

export default DashboardStats_02;
